import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const T = {
  teal: '#5EEAD4', lavender: '#C4B5FD', coral: '#FDA4AF',
};

const NotFound: React.FC = () => (
  <div className="relative z-10 min-h-screen flex items-center justify-center px-4 sm:px-6">
    <motion.div
      className="text-center max-w-lg"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      {/* Big 404 */}
      <h1 className="text-[10rem] sm:text-[12rem] font-black leading-none select-none"
        style={{
          background: `linear-gradient(135deg, ${T.teal}, ${T.lavender}, ${T.coral})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        404
      </h1>

      <h2 className="text-2xl sm:text-3xl font-bold text-slate-800 mb-4 -mt-4">
        Looks like this ride went off-route
      </h2>
      <p className="text-slate-500 mb-8 text-lg">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/"
          className="inline-flex items-center justify-center px-8 py-3 bg-slate-800 rounded-2xl text-white font-bold shadow-lg hover:bg-slate-700 transition-all"
        >
          Back to Home
        </Link>
        <Link
          to="/faq"
          className="inline-flex items-center justify-center px-8 py-3 rounded-2xl font-bold border border-slate-200 text-slate-600 hover:bg-slate-50 transition-all"
        >
          Visit FAQ
        </Link>
      </div>
    </motion.div>
  </div>
);

export default NotFound;
